<div class="dispute-management">
    <app-header
        [title]="'support.dispute-management.header.title' | translate"
        [hasBackButton]="false"
        [hasSearchButton]="false"
        [searchInput]="filter"
        [searchPlaceholder]="'support.dispute-management.header.filter' | translate"
        (onSearch)="onSearch($event)"
    >
        <button customButton styleType="primary" [isLoading]="false" label="support.dispute-management.header.buttons.refresh" (click)="loadScreen()" [outline]="true" iconName="refresh-cw" ></button>
    </app-header>
    <div class="cadastro-cnpj-oficina" ngxUiLoaderBlurred [loaderId]="'loader-principal'">
        <div class="corpo-pagina">
            <div class="card card-default">
                <app-support-gridview [config]="config" [templates]="templatesArray" (onApprove)="approveDispute($event)" [hasLineClick]="true" (onLineClick)="openDetail($event)" (onReject)="rejectDispute($event)"></app-support-gridview>

                <ng-template #infoTemplate let-item>
                    <i-feather class="info-icon" name="info" tooltip="{{item.disputeReason}}"></i-feather>
                </ng-template>

                <ng-template #statusTemplate let-item>
                    <div class="pill-label">
                        {{ 'support.dispute-management.table.status.pending' | translate }}
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
<ngx-ui-loader [loaderId]="'loader-principal'"></ngx-ui-loader>
<app-dispute-detail #templateDisputeDetail />
